<mat-card class="rounded-2xl border border-gray-6 shadow-sm h-full overflow-hidden">
  <mat-card-header class="bg-gray-1 py-4 px-6 border-b border-gray-6 flex flex-row items-center w-full">
    <div class="flex items-center gap-3">
      <div class="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-3 text-brand-11">
        <mat-icon>photo_camera</mat-icon>
      </div>
      <mat-card-title class="text-lg! font-bold! m-0! text-gray-12!">Visite photo</mat-card-title>
    </div>
    @if (editable()) {
      <div class="ml-auto flex items-center gap-2">
        <etxe-property-section-reminder
          [items]="missingItems()"
          [editMode]="editMode()"
          (actionClicked)="onEdit()"
        />
        <button
          mat-icon-button
          class="text-brand-11 bg-brand-a3 hover:bg-brand-a4 transition-colors rounded-full"
          (click)="editMode() ? onCancel() : onEdit()"
        >
          <mat-icon>{{ editMode() ? 'close' : 'edit' }}</mat-icon>
        </button>
      </div>
    }
  </mat-card-header>
  <mat-card-content class="p-0">
    @if (!editMode()) {
      <div class="p-6">
        <etxe-property-photos-display [media]="property().media"></etxe-property-photos-display>
      </div>
    } @else {
      <div class="bg-gray-2 p-6 flex flex-col gap-6">
        <!-- Reusing the form from the creation stepper -->
        <etxe-property-photos-form
          [propertyId]="property()._id"
          [dto]="{ photos: property().media.photos || [] }"
          [propertyCharacteristics]="property().characteristics"
          (dtoChanged)="onDtoChanged($event)"
        ></etxe-property-photos-form>

        <div class="flex justify-end gap-3 mt-6 border-t border-gray-6 pt-4">
          <button mat-button (click)="cancelToggled.emit()">Annuler</button>
          <button mat-flat-button class="primary" [disabled]="saving()" (click)="submitted.emit()">
            Enregistrer
          </button>
        </div>
      </div>
    }
  </mat-card-content>
</mat-card>
